module.exports = __webpack_public_path__ + "img/minus.215119f.svg";